const BasicError = (props) => <div className="mt-1 text-red-500 text-sm" {...props}/>

export default BasicError;